import { render, staticRenderFns } from "./SpcMailManager.vue?vue&type=template&id=48d96bb6&scoped=true&"
import script from "./SpcMailManager.script.js?vue&type=script&lang=js&"
export * from "./SpcMailManager.script.js?vue&type=script&lang=js&"
import style0 from "./SpcMailManager.scss?vue&type=style&index=0&id=48d96bb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d96bb6",
  null
  
)

export default component.exports